module.exports = __webpack_public_path__ + "img/wf-contents.d635b97a.svg";